import { FC } from 'react';
import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { CheckoutConfirmationTableLayout } from 'src/pages/Checkout/components/common/TableLayout';
import { commonFormatCurrencyWithType } from 'src/utils/currency';

type Props = {
  model: CheckoutConfirmationResponseType['TicketingGroupRegistrationsSubsection'];
};

export const CheckoutTicketingGroupRegistrations: FC<Props> = ({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.ticketingGroupRegistrations');

  return (
    <>
      <h2 className="section-header">{model.SectionHeader}</h2>
      {model.Items.map((item, index) => (
        <CheckoutConfirmationTableLayout
          /* eslint-disable-next-line react/no-array-index-key */
          key={index}
          tHead={
            <tr>
              <th className="left">{model.TicketGroupsTerminology.Singular}</th>
              <th className="right">{tHelper('information')}</th>
            </tr>
          }
        >
          <tr>
            <td className="left">{model.TicketGroupsTerminology.Singular}</td>
            <td className="right">{item.ItemTitle}</td>
          </tr>
          <tr>
            <td className="left">{tHelper('id', { terminology: model.TicketGroupsTerminology.Singular || '' })}</td>
            <td className="right">{item.CampaignGroupRegistrationId}</td>
          </tr>
          <tr>
            <td className="left">{tHelper('price')}</td>
            <td className="right">
              {item.Amount > 0 ? commonFormatCurrencyWithType(item.Amount, model.CurrencyType) : tHelper('free')}
            </td>
          </tr>
          {item.GroupName && (
            <tr>
              <td className="left">{tHelper('name', { terminology: model.TicketGroupsTerminology.Singular || '' })}</td>
              <td className="right">{item.GroupName}</td>
            </tr>
          )}
          {item.CustomFields.map((field) => (
            <tr key={field.Name}>
              <td className="left">{field.Name}</td>
              <td className="right">{field.Value}</td>
            </tr>
          ))}
        </CheckoutConfirmationTableLayout>
      ))}
    </>
  );
};
